const form = {
    switch: {
        offsymbol: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 12,
            color: "#fff",
            paddingRight: 2,
        },
        onSymbol: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 12,
            color: "#fff",
            paddingRight: 2,
        }
    },
    toastr: {
        closeButton: true,
        debug: false,
        extendedTimeOut: "1000",
        hideDuration: "1000",
        hideEasing: "linear",
        hideMethod: "fadeOut",
        newestOnTop: false,
        positionClass: "toast-top-right",
        preventDuplicates: true,
        progressBar: true,
        showDuration: "300",
        showEasing: "swing",
        showMethod: "fadeIn",
        timeOut: "3000",
    },
    action: {
        add: 'ADD',
        view: 'VIEW',
        edit: 'EDIT',
        delete: 'DELETE',
    },
    flatpickr: {
        altInput: false,
        altFormat: "F j, Y",
        dateFormat: "d-m-Y",
        locale: {
            firstDayOfWeek: 1,
            weekdays: {
                shorthand: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
                longhand: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
            },
            months: {
                shorthand: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Оct', 'Nov', 'Dic'],
                longhand: ['Enero', 'Febrero', 'Мarzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            },
        }
    },
    date: {
        formatBD: 'DD-MM-YYYY' ,
        formatPOSTGRES: 'YYYY-MM-DD' 
    },
    month:[
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ]
}

export default {
    form
};